var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3475_77315",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3475_77315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.54244 16.8004L11.9984 13.3444L15.4544 16.8004L16.7984 15.4564L13.3424 12.0004L16.7984 8.54439L15.4544 7.20039L11.9984 10.6564L8.54244 7.20039L7.19844 8.54439L10.6544 12.0004L7.19844 15.4564L8.54244 16.8004ZM11.9984 21.6004C10.6704 21.6004 9.42244 21.3484 8.25444 20.8444C7.08644 20.3404 6.07044 19.6564 5.20644 18.7924C4.34244 17.9284 3.65844 16.9124 3.15444 15.7444C2.65044 14.5764 2.39844 13.3284 2.39844 12.0004C2.39844 10.6724 2.65044 9.42439 3.15444 8.25639C3.65844 7.08839 4.34244 6.07239 5.20644 5.20839C6.07044 4.34439 7.08644 3.66039 8.25444 3.15639C9.42244 2.65239 10.6704 2.40039 11.9984 2.40039C13.3264 2.40039 14.5744 2.65239 15.7424 3.15639C16.9104 3.66039 17.9264 4.34439 18.7904 5.20839C19.6544 6.07239 20.3384 7.08839 20.8424 8.25639C21.3464 9.42439 21.5984 10.6724 21.5984 12.0004C21.5984 13.3284 21.3464 14.5764 20.8424 15.7444C20.3384 16.9124 19.6544 17.9284 18.7904 18.7924C17.9264 19.6564 16.9104 20.3404 15.7424 20.8444C14.5744 21.3484 13.3264 21.6004 11.9984 21.6004Z",
    fill: "#181716"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.b7197f3a7b804e38f0d42ff8d5b11f1f.svg";
export { ForwardRef as ReactComponent };